export {
  default as nightLighting,
  ReactComponent as NightLighting,
} from '@assets/icons/features-and-amenities/night-lighting.svg'    
